var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftRedBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 639,
    height: 41.834,
    viewBox: "0 0 639 41.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2233",
    "data-name": "Group 2233",
    transform: "translate(0 -111.158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 5,
    height: 639,
    transform: "translate(639 129.575) rotate(90)",
    fill: "#c71e2d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 639,
    dur: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 5,
    height: 227,
    transform: "translate(227 111.158) rotate(90)",
    fill: "#c71e2d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 639,
    dur: "1s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 5,
    height: 448,
    transform: "translate(448 147.992) rotate(90)",
    fill: "#c71e2d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    from: 0,
    to: 639,
    dur: "1s",
    fill: "freeze"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRedBars);
export default __webpack_public_path__ + "static/media/left_red_bars.977e636bc92f931f3caebb947b78c260.svg";
export { ForwardRef as ReactComponent };